$(document).ready(function () {
  // Gift Card Page
  var currentPath = window.location.pathname;

  // Check if the path matches "/products/gift-card-1"
  if (currentPath === "/products/gift-card-1") {
    if ($(".product-media-modal__dialog").length) {
      // Gift card fix - Removes the wrong attributes from the dialog
      setTimeout(function () {
        $(".product-media-modal__dialog").removeAttr(
          "tabindex role aria-label"
        );
      }, 2000);

      // Gift card page checkbox aria-expanded aria-controls fix
      // Select checkbox using wildcard for id
      const giftOptionCheckbox = document.querySelector(
        "[id*='Recipient-checkbox']"
      );

      if (giftOptionCheckbox) {
        // Set initial state for aria-expanded attribute based on the checked state
        const initialCheckedState = giftOptionCheckbox.checked;
        giftOptionCheckbox.setAttribute(
          "aria-expanded",
          initialCheckedState ? "true" : "false"
        );

        // Function to toggle the checkbox state and aria-expanded attribute
        function toggleCheckboxState() {
          const isChecked = giftOptionCheckbox.checked;
          giftOptionCheckbox.setAttribute(
            "aria-expanded",
            isChecked ? "true" : "false"
          );
        }

        // Attach event listener to the checkbox to toggle attributes
        giftOptionCheckbox.addEventListener("change", toggleCheckboxState);

        // Add id "gift_option_panel" to the specified div element
        const giftOptionPanel = document.querySelector(
          "[id*='Recipient-checkbox'] ~ .recipient-fields"
        );

        if (giftOptionPanel) {
          giftOptionPanel.id = "gift_option_panel";
        }

        // Add aria-controls attribute to the checkbox
        giftOptionCheckbox.setAttribute("aria-controls", "gift_option_panel");
      }
    }
  }
});
